import request from '@/utils/request'
/**
 * @fileOverview 初评
*/

/**
* @description 分类列表
* @param {string} type  1-初评 2-复评
*/
export function reviewsIndexBefore(type) {
  return request({
    url: `/reviews/indexBefore/${type}`,
    method: 'get'
  })
}

/**
* @description 分类列表
* @param {string} type  1-初评 2-复评
* @param {string} category_id  类别id
*/
export function reviewsIndexBeforeByCate(type, category_id) {
  return request({
    url: `/reviews/indexBefore/${type}/${category_id}`,
    method: 'get'
  })
}

/**
* @description 初评列表
*/
export function reviewsPrimary() {
  return request({
    url: '/reviews/primary',
    method: 'get'
  })
}

/**
* @description 初评作品列表
 * @param {string} params.user_id  初评id
*/
export function reviewsPrimaryProduct(params) {
  return request({
    url: `/reviews/primaryProduct`,
    method: 'get',
    params
  })
}

/**
* @description 初评整体评分表
*/
export function reviewsPrimarySearch(params) {
  return request({
    url: `/reviews/primarySearch`,
    method: 'get',
    params
  })
}

/**
* @description 初评整体评分作品表
* @param {string} data.category_id  类别id
 * @param {string} data.user_id  初评id
* @param {string} data.sort  排序 asc升序desc降序
*/
export function reviewsPrimarySearchPost(data) {
  return request({
    url: `/reviews/primarySearch`,
    method: 'post',
    data
  })
}

/**
* @description 初评结果
*/
export function reviewsPrimaryResult(params) {
  return request({
    url: `/reviews/primaryResult`,
    method: 'get',
    params
  })
}

/**
* @description 导出初评结果
*/
export function reviewsPrimaryOutput() {
  return request({
    url: `/reviews/primaryOutput`,
    method: 'get'
  })
}

/**
* @description 复评列表
*/
export function reviewsNomination() {
  return request({
    url: `/reviews/nomination`,
    method: 'get'
  })
}

/**
* @description 复评作品列表
* @param {string} params.category_id  分类
* @param {string} params.search  编号或名称
* @param {string} params.status  状态
*/
export function reviewsNominationProduct(params) {
  return request({
    url: `/reviews/LastProduct`,
    method: 'get',
    params
  })
}

/**
* @description 复评整体评分表
*/
export function reviewsNominationSearch(params) {
  return request({
    url: `/reviews/nominationSearch`,
    method: 'get',
    params
  })
}

/**
* @description 复评整体评分作品表（POST）
* @param {Object} data
* @param {Array<number>} data.category_id
* @param {number} data.user_id
* @param {string} data.sort
*/
export function reviewsNominationSearchPost(data) {
  return request({
    url: `/reviews/nominationSearch`,
    method: 'post',
    data
  })
}

/**
* @description 复评整体评分作品表
* @param {string} category_id  类别id
* @param {string} user_id  初评id
*/
export function reviewsNominationWhole(category_id, user_id) {
  return request({
    url: `/reviews/nominationWhole/${category_id}/${user_id}`,
    method: 'get'
  })
}

/**
* @description 复评结果
*/
export function reviewsNominationResult(params) {
  return request({
    url: `/reviews/nominationResult`,
    method: 'get',
    params
  })
}

/**
* @description 导出复评结果
*/
export function reviewsNominationOutput() {
  return request({
    url: `/reviews/nominationOutput`,
    method: 'get'
  })
}

/**
* @description 作品详情
* @param {string} type  1-初评 2-复评
* @param {string} user_id  初评id
*/
export function reviewsProduct(id, user_id, type) {
  return request({
    url: `/products/${id}`,
    method: 'get'
  })
}

/**
* @description 作品评分
* @param {string} type  1-初评 2-复评
* @param {string} data.score  提交评奖分数
*/
export function updateReviewsProduct(id, type, data) {
  return request({
    url: `/reviews/product/${id}/${type}`,
    method: 'put',
    data
  })
}

/**
* @description 更新整体评分
* @param {string} category_id  类别id
* @param {string} user_id  初评id
* @param {string} type  1-初评 2-复评
* @param {string} data.lists  整体评分数组数据
*/
export function reviewsUpdateWhole(user_id, type, data) {
  return request({
    url: `/reviews/updateWhole/${user_id}/${type}`,
    method: 'put',
    data
  })
}

/**
* @description 管理员修改评分
* @param {string} id  产品id
* @param {string} type  1-初评 2-复评
* @param {string} data.lists  评分数组数据
*/
export function reviewsUpdateResult(id, type, data) {
  return request({
    url: `/reviews/updateResult/${id}/${type}`,
    method: 'put',
    data
  })
}

/**
* @description 初评欢迎状态
*/
export function reviewsStart() {
  return request({
    url: `/reviews/start`,
    method: 'get'
  })
}

/**
* @description 类别查询
* @param {string} type  1-初评 2-复评
 * @param {string} user_id  初评id
*/
export function reviewsSearchBefore(type, user_id) {
  return request({
    url: `/reviews/searchBefore/${type}/${user_id}`,
    method: 'get'
  })
}

/**
* @description 评奖作品备注
* @param {string} id  作品id
* @param {string} data.winner_remark 备注
*/
export function reviewsRemarkProduct(id, data) {
  return request({
    url: `/reviews/remarkProduct/${id}`,
    method: 'put',
    data
  })
}

/**
* @description 初评评分表保存分数
* @param {number} data.user_id  用户id
* @param {number} data.product_id  作品id
* @param {number} data.score 分数
*/
export function reviewsUpdateScore(data) {
  return request({
    url: `/reviews/updateScore`,
    method: 'put',
    data
  })
}
